import { render } from "./MobileNotificationCenter.vue?vue&type=template&id=2ed0e9f1"
import script from "./MobileNotificationCenter.vue?vue&type=script&lang=js"
export * from "./MobileNotificationCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__